module.exports = __webpack_public_path__ + "img/landingpage_2023.cb9769e4.png";